<template>
  <form>
    <div :id="this.defaultDivId" class="vs-con-loading__container">

      <!-- Conduta -->
      <vs-row vs-w="12">
        <div>
          <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
            <label for class="vs-input--label">Conduta</label>
          </vs-col>

          <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
            <quill-editor v-model="data.medicalConduct"></quill-editor>
          </vs-col>
        </div>
      </vs-row>

      <br />

      <vs-row>
        <vs-col vs-type="flex" vs-align="right" vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-button @click="submit">Salvar</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </form>
</template>

<script>
// QuillEditor
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

import AppointmentService from "../../../services/AppointmentService";

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      data: {
        id: 0,
        idAppointment: 0,
        diagnostics: "",
        appointmentReason: "",
        clinicAndDietaryHistory: "",
        medicalConduct: "",
        description: "",
      },
      notifications: {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: true,
        showError: true
      },
      defaultDivId: "div-appointment-medical-conduct",
    };
  },
  mounted: function() {
    this.get();
  },
  beforeDestroy: function() {
    this.submit();
  },
  created() {
    this.data.idAppointment = this.$route.params.id;
  },
  methods: {
    async submit() {
      console.log(this.data.id);
      if (this.data.id != null && this.data.id > 0) {
        this.update();
      } else {
        this.create();
      }
    },
    async get() {
      console.log("get", this.data.idAppointment);
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: {
          idAppointment: this.data.idAppointment
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;

      var result = await AppointmentService.get(payload);
      if (result.status == 200) {
        if (result.data.result != null) {
          this.data = result.data.result;
        }
      }

      this.closeLoadingDiv(this.defaultDivId);
    },
    async create() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentService.create(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    async update() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentService.update(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    openLoadingInDiv(divId) {
      this.$vs.loading({
        container: "#" + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close("#" + divId + " > .con-vs-loading");
    }
  }
};
</script>

<style scoped>
.label {
  padding-left: 5px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}
</style>